import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

// Hitting /dashboard directly lands here, then bounces to the right branch.
export default function DashboardHome() {
  const { session, profile, loading } = useAuth();

  if (loading) return null;
  if (!session || !profile) return <Navigate to="/dashboard/login" replace />;

  return (
    <Navigate to={profile.role === "client" ? "/dashboard/client" : "/dashboard/agency"} replace />
  );
}
